// extracted by mini-css-extract-plugin
module.exports = {"articleheader":"ArticleHeader_articleheader__f9Z0c","pageheadermeta":"ArticleHeader_pageheadermeta__Dc4PK"};